import React from 'react';


function Button (props) {
    return <button
        className="btn btn-default"
        style={{
            float: 'right'
        }}
        title="assign"
        {...props}
    >
        {props.children}
    </button>;
}

function ButtonAssign (props) {
    return <Button {...props}>
        <span className="glyphicon glyphicon-ok" aria-hidden="true"></span>
    </Button>;
}

function ButtonRemove (props) {
    return <Button {...props}>
        <span className="glyphicon glyphicon-minus" aria-hidden="true"></span>
    </Button>;
}

function ButtonEdit (props) {
    return <Button {...props}>
        <span className="glyphicon glyphicon-pencil" aria-hidden="true"></span>
    </Button>;

}

export default {
    Assign: ButtonAssign,
    Remove: ButtonRemove,
    Edit: ButtonEdit
};
